import {BasicObject} from '@/types';
import React from 'react';
import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import dayjs from 'dayjs';
import {useTranslation} from 'react-i18next';
import DigitBall from '../../../digit/components/digit-ball';

const DigitsResult = ({info = {}}: {info: BasicObject}) => {
  const {i18n} = useTranslation();
  const CodeArr = React.useMemo(() => {
    if (info.wonCode) {
      return info.wonCode.split('');
    }
    return [];
  }, [info.wonCode]);

  // 根据结果位数生成对应的标签
  const getLabels = (resultLength: number): string[] => {
    switch (resultLength) {
      case 3:
        return ['A', 'B', 'C'];
      case 4:
        return ['Z', 'A', 'B', 'C'];
      case 5:
        return ['Y', 'Z', 'A', 'B', 'C'];
      default:
        return ['A', 'B', 'C'];
    }
  };

  const labels = getLabels(CodeArr.length);

  return (
    <View
      style={[
        theme.background.white,
        theme.padding.l,
        // theme.flex.row,
        theme.flex.centerByCol,
        theme.margin.btml,
      ]}>
      <View
        style={[theme.flex.row, theme.flex.centerByCol, theme.padding.btmxxs]}>
        <View style={[theme.flex.row, theme.flex.centerByCol]}>
          <Text color={theme.fontColor.accent} size="medium">
            {dayjs(info.gameDrawTime).format('YYYY-MM-DD')}{' '}
          </Text>
          <Text fontFamily="fontInterBold" size="medium">
            {dayjs(info.gameDrawTime).format('hh:mm A')}{' '}
          </Text>
        </View>
        <Text fontFamily="fontInterBold" size="medium">
          {i18n.t('bets-detail.label.drawRes')}:
        </Text>
      </View>
      <View
        style={[
          theme.flex.flex1,
          theme.flex.row,
          theme.flex.centerByCol,
          theme.flex.end,
          styles.gap,
        ]}>
        <View style={[theme.flex.row, theme.flex.centerByCol, styles.gap]}>
          {labels.map((item, index) => (
            <DigitBall
              key={index}
              digit={item}
              color={item}
              ballSize={24}
              fontSize={10}
            />
          ))}
        </View>
        <Text size="medium" fontFamily="fontInterBold">
          =
        </Text>
        <View style={[theme.flex.row, theme.flex.centerByCol, styles.gap]}>
          {labels.map((item, index) => (
            <DigitBall
              key={index}
              digit={CodeArr[index] || '*'}
              color={item}
              ballSize={24}
              fontSize={10}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  gap: {
    columnGap: 4,
  },
});

export default DigitsResult;
